/* eslint-disable react/require-default-props */
/* eslint-disable no-param-reassign */
import React, { memo } from 'react';
import Select from 'react-select';
import { colors } from 'src/utils/colors';

const customStyles = ({ width }: { width?: string }) => {
	return {
		control: (base: any) => ({
			...base,
			height: '100%',
			minHeight: '100%',
			background: 'transparent',
			border: 'none',
			outline: 'none',
			boxShadow: 'none',
		}),
		singleValue: (base: any) => ({
			...base,
			fontWeight: '600',
			fontSize: '15px',
			color: 'white',
		}),
		dropdownIndicator: (styles: any) => ({
			...styles,
			paddingTop: 0,
			paddingBottom: 0,
			color: colors.primary,
			paddingLeft: 0,
			paddingRight: 0,
			'&:hover': {
				color: colors.primary,
			},
		}),

		menu: (provided: any) => ({
			...provided,
			background: 'green',
			top: '25px',
			right: 0,
			border: `1px solid ${colors.primary}`,
			minWidth: '100px',
		}),
		menuList: (provider: any) => ({
			...provider,
			padding: 0,
			background: colors.liteBackground,
		}),
		valueContainer: (provided: any) => ({
			...provided,
			padding: '0 2px',
		}),
		option: (provided: any, state: any) => ({
			...provided,
			color: state.isSelected ? 'white' : colors.primary,
			background: state.isSelected ? colors.primary : colors.liteBackground,
			'&:hover': {
				background: colors.primary,
				color: 'white',
			},
		}),
	};
};

const SelectOverview = ({
	options,
	isDisabled,
	value,
	onChange,
	isMulti,
	onInputChange,
	inputValue,
	isSearchable,
	closeMenuOnSelect,
	menuPlacement,
	placeholder,
	isLoading,
	maxMenuHeight,
	width,
}: {
	options?: any;
	isDisabled?: boolean;
	value: any;
	onChange?: any;
	inputValue?: string;
	onInputChange?: (input: string) => void;
	isMulti?: boolean;
	isSearchable?: boolean;
	closeMenuOnSelect?: boolean;
	placeholder?: string;
	isLoading?: boolean;
	maxMenuHeight?: number;
	menuPlacement?: 'auto' | 'bottom' | 'top';
	width?: string;
}) => {
	const onChangeInputElement = (text: string, { action }: any) => {
		console.log(text)
		if (action === 'input-change' && onInputChange) {
			console.log('text')
			onInputChange(text);
		}
	};
	return (
		<Select
			styles={customStyles({ width })}
			placeholder={placeholder}
			isSearchable={isSearchable}
			isMulti={isMulti}
			onInputChange={(e) => {console.log(e)}}
			inputValue={inputValue}
			isLoading={isLoading}
			closeMenuOnSelect={closeMenuOnSelect}
			options={options}
			menuPlacement={menuPlacement || 'auto'}
			isDisabled={isDisabled}
			onChange={onChange}
			value={value}
			maxMenuHeight={maxMenuHeight}
			components={{
				IndicatorSeparator: () => null,
			}}
		/>
	);
};

export default memo(SelectOverview);
